import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { SignaturePad } from "angular2-signaturepad";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

import {
  HttpClient,
  HttpParams,
  HttpRequest,
  HttpHeaders,
} from "@angular/common/http";

import { environment } from "./../../../environments/environment";
import { ApiHelper } from "./../../_helpers/api.helper";
import { CommonHelper } from "./../../_helpers/common.helper";
import { ConstantHelper } from "./../../_helpers/constant.helper";
import { AppConfig } from "./../../../app/app.config";
import { SweetAlertHelper } from "src/app/_helpers/sweet.alert.helper";
import { Message } from "src/app/_locale/message";
import { async } from "@angular/core/testing";

@Component({
  selector: "app-view-docs-acknowledgement",
  templateUrl: "./view-docs-acknowledgement.component.html",
  styleUrls: ["./view-docs-acknowledgement.component.scss"],
})
export class ViewDocsAcknowledgementComponent implements OnInit {
  pId: string;
  userId: string;
  patientName: string;
  loggedInUserObj: any = {};
  patientObj: any = {};
  imageObj: any = {};
  imageUrl: string;
  showLoader = false;
  doctorName: any = "";

  resultJsonObj: any = {};
  @ViewChild(SignaturePad, { static: false }) signaturePad: SignaturePad;
  @ViewChild("canvasArea", { static: true }) canvasArea: ElementRef;
  canvasElm: any;
  // tslint:disable-next-line: ban-types
  public signaturePadOptions: Object = {
    // passed through to szimek/signature_pad constructor
    minWidth: 1,
    canvasWidth:
      window.innerWidth < 1024 ? window.innerWidth : window.innerWidth / 2,
    canvasHeight: 450,
  };

  httpHeaders = new HttpHeaders({
    "Content-Type": "application/json",
  });
  httpOptions = {
    headers: this.httpHeaders,
  };
  message = Message;
  constructor(
    public commonHelper: CommonHelper,
    private appConfig: AppConfig,
    private formBuilder: FormBuilder,
    public sweetAlertHelper: SweetAlertHelper,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.pId = this.activatedRoute.snapshot.paramMap.get("pId");
    this.findPatientUserInfo(this.pId);
  }

  // tslint:disable-next-line: use-lifecycle-interface
  ngAfterViewInit() {
    // this.signaturePad is now available
    this.signaturePad.set("minWidth", 1); // set szimek/signature_pad options at runtime
    this.signaturePad.clear(); // invoke functions from szimek/signature_pad API
  }
  drawComplete() {
    // will be notified of szimek/signature_pad's onEnd event
    // console.log(this.signaturePad.toDataURL());
  }
  async clearCanvas() {
    // if (confirm('PLEASE CONFIRM: Are you sure you want to clear you signature.'))
    const alertStatus = await this.sweetAlertHelper.confirmPopUp(
      this.message.confirmTitle,
      this.message.confirmMessages.addAcknowd2dDocComp.clearCanvas
    );
    {
      this.signaturePad.clear();
    }
  }
  drawStart() {
    // will be notified of szimek/signature_pad's onBegin event
    // console.log("begin drawing");
  }
  findPatientUserInfo(patientUserHashId) {
    const finalData = {
      company_slug: ConstantHelper.COMPANY_SLUG,
      profileId: patientUserHashId,
    };
    return this.http
      .post(
        this.appConfig.getPhpUrl() + ApiHelper.php_findUserDetailsByUserHashApi,
        finalData,
        this.httpOptions
      )
      .subscribe(
        (apiResponse: any) => {
          this.patientObj = apiResponse;
          // console.log('patienthash', apiResponse.commandResult.data.UserInfo);
          this.patientName = apiResponse.commandResult.data.UserInfo.FullName;
          this.userId = apiResponse.commandResult.data.UserInfo.RecordId;
        },
        (err) => {
          // console.log(err);
        }
      );
  }

  async saveCanvas() {
    // if (confirm('PLEASE CONFIRM: By clicking \'OK\', you are signing the document and now will be able to review each.'))
    const alertStatus = await this.sweetAlertHelper.confirmPopUp(
      this.message.confirmTitle,
      this.message.confirmMessages.signaturewaiverComp.saveCanvas
    );
    {
      const finalData = {
        signatureBase64: this.signaturePad.toDataURL(),
        pId: this.pId,
        userId: this.userId,
      };
      return this.http
        .post(
          this.appConfig.getLambdaUrl05() +
            ApiHelper.name_generateViewDocSignatureImageApi,
          finalData,
          this.httpOptions
        )
        .subscribe(
          (apiResponse: any) => {
            this.imageObj = apiResponse;
            this.imageUrl =
              apiResponse.commandResult.data.fileInfo.signatureUrl;
            // console.log('imageUrl', this.imageUrl);
            this.http
              .post(
                this.appConfig.getPhpUrl() +
                  ApiHelper.php_generateViewDocSignatureFilePdfApi,
                finalData,
                this.httpOptions
              )
              .subscribe(
                // tslint:disable-next-line:variable-name
                async (_apiResponse: any) => {
                  //this.showLoader = false;
                  // console.log(_apiResponse);
                  // alert("Acknowledgement sent to the patient.");
                  const alertStatus = await this.sweetAlertHelper.alertPopUp(
                    this.message.alertMessages.userDocAcknowledgeComp.saveCanvas
                  );
                  if (alertStatus)
                    this.router.navigate([
                      "/admin/user-docs/" + this.pId + "/" + this.userId,
                    ]);
                },
                (err) => {
                  // console.log(err);
                }
              );
          },
          (err) => {
            // console.log(err);
          }
        );
    }
  }
}
